// removed by extract-text-webpack-plugin
module.exports = {"TruncatedCell":"TruncatedCell__2k2aCJFXTU6N"};